import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "slot-machine" }
const _hoisted_2 = { class: "slot-target" }
const _hoisted_3 = { class: "corner tl" }
const _hoisted_4 = { class: "pip" }
const _hoisted_5 = { class: "corner br" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "t-label" }, "BEAT", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetSymbols, (s, i) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(["t-card", { red: _ctx.isRed(s) }]),
          key: i
        }, [
          _createElementVNode("b", null, _toDisplayString(s), 1),
          _createTextVNode(_toDisplayString(_ctx.SUIT[s]), 1)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["slot-frame", _ctx.tint])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reels, (reel, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["reel", { spinning: reel.spinning }]),
          key: i
        }, [
          _createElementVNode("div", {
            class: "reel-strip",
            style: _normalizeStyle(reel.spinning ? '' : `transform: translateY(-${reel.targetIndex * 64}px)`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reel.symbols, (sym, j) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "reel-cell",
                key: j
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card", { red: _ctx.isRed(sym), ace: sym === _ctx.TOP }])
                }, [
                  _createElementVNode("span", _hoisted_3, [
                    _createElementVNode("b", null, _toDisplayString(sym), 1),
                    _createElementVNode("i", null, _toDisplayString(_ctx.SUIT[sym]), 1)
                  ]),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.SUIT[sym]), 1),
                  _createElementVNode("span", _hoisted_5, [
                    _createElementVNode("b", null, _toDisplayString(sym), 1),
                    _createElementVNode("i", null, _toDisplayString(_ctx.SUIT[sym]), 1)
                  ])
                ], 2)
              ]))
            }), 128))
          ], 4)
        ], 2))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["slot-base", _ctx.tint])
    }, _toDisplayString(_ctx.ruleLabel), 3)
  ]))
}